<template>
  <a-drawer
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :closable="false"
    :headerStyle="{paddingTop:'0px'}"
    :bodyStyle="{background:'#F4F9FD',padding: 0 }"
    :drawerStyle="{background:'#F4F9FD',overflowY:'hidden'}"
    @close="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <div class="worder-content">
        <div style="color: #111111;font-size: 16px;margin-left: 24px">平台详情</div>
        <platform-info-top :model="ptModel" v-if="this.dmPlatformId"  @change="changeTab" @update="loadConfig"></platform-info-top>
        <div class="worder-info">
          <info-menu :menuList="tabList" v-if="this.dmPlatformId" :tab="leftMap.leftTab" @change="changeTab"></info-menu>
          <div v-if="leftMap.leftTab==1" :style="{marginTop: this.dmPlatformId?0:'18px'}">
            <div class="driver-operate-box" v-if="disableSubmit">
              <div>
                <a-button type="primary" @click="disableSubmit = false;" icon="form"
                          style="height: 36px !important;border-radius: 18px;font-size: 14px">修改信息</a-button>
              </div>
              <div class="operate-btn-box">
<!--                <div class="operate-btn-box-span" @click="disableSubmit = false;">-->
<!--                  <icon-font class="operate-btn-icon" type="icon-xiugai"></icon-font>-->
<!--                  <span>修改信息</span>-->
<!--                </div>-->
                <div class="operate-btn-box-span" @click="loadConfig(1)" >
                  <icon-font class="operate-btn-icon" type="icon-shuaxin"></icon-font>
                  <span>重新加载</span>
                </div>
              </div>
              <div class="driver-update-box">
                <img :src="getFileAccessHttpUrl(ptModel.updateAvatar)" v-if="ptModel.updateAvatar"/>
                <span>{{ptModel.updateByName}}</span>
                <span>更新于{{ptModel.updateTime}}</span>
              </div>
            </div>
            <div class="driver-save-box" v-else>
              <a-button type="primary" class="save-btn" icon="save" @click="savePtInfo">保存</a-button>
              <a-button  class="save-btn" icon="close-circle" v-if="this.dmPlatformId" @click="cancelPt">取消</a-button>
            </div>
          </div>
          <dm-platform-form v-if="leftMap.leftTab===1" :subHeight="this.dmPlatformId?272:128" @hasChange="hasChange" ref="realForm" :form-data="ptModel"  @ok="getInfo"  @getData="getData" @getInfo="getInfo" @close="closeTab"  :disabled="disableSubmit"></dm-platform-form>
          <gmv-table ref="gmvTable" v-if="leftMap.leftTab==2 && dmPlatformId" :ddpId="dmPlatformId"></gmv-table>
        </div>
      </div>
    </a-spin>
  </a-drawer>
</template>

<script>

import { mixin, mixinDevice } from '@/utils/mixin.js'
import { PlatformModelInfoMixins } from '@/mixins/dm5/driver/PlatformModelInfoMixins'

import { checkHasPer } from "@/utils/authFilter"

import InfoMenu from "@comp/dm5/InfoMenu.vue";
import {getFileAccessHttpUrl} from "@api/manage";
import PlatformInfoTop from "@comp/dm5/driver/PlatformInfoTop.vue";
import DmPlatformForm from "@views/dm5/components/DmPlatformForm.vue";
import DmCarForm from "@views/dm5/components/DmCarForm.vue";
import GmvTable from "@comp/dm/platform/GmvTable.vue";

export default {
  methods: {getFileAccessHttpUrl},
  inject:['closeCurrent'],
  name: 'PlatformModalInfo',
  mixins: [mixin, mixinDevice,PlatformModelInfoMixins],
  components: {
    GmvTable,
    DmCarForm,
    DmPlatformForm,
    PlatformInfoTop,
    InfoMenu,
    checkHasPer
  }
}
</script>

<style lang="less" scoped>
@import '~@assets/less/dm5/driver/driverInfo.less';

/deep/ .ant-form-item{
  width: 100%;
  margin-bottom: 0 !important;
}
</style>